import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store'
import { Products, DataEntity } from "@/entity/warehouse/Products/Products.types"
import { PaginationRequestType } from "@/entity/common/pagination.types"
import { ResponseDataType } from "@/form/form.types"
import { ProductsAddRequestType, ProductsUpdateRequestType} from "@/entity/warehouse/Products/Products"
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'products',
    store,
    dynamic: true,
})
class ProductsModule extends VuexModule implements IStoreReady {
    products: Products | null = null;
    product: DataEntity | null = null;
    productsLoaded = false
    productLoaded = false
    ready = false

    @MutationAction
    async fetchAll( data?: PaginationRequestType ): Promise< { products: Products; productsLoaded: boolean} >{
        let productsLoaded = false
        const products = await store.$repository.products.fetchAll(prepareFormData(data))
        if (products) {
            productsLoaded = true
        }
        return { products, productsLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ product: DataEntity; productLoaded:boolean }> {
        let productLoaded = false
        const product = await store.$repository.products.fetchData(data)
        if (product) {
            productLoaded = true
        }
        return {product, productLoaded}
    }
    @Action({rawError: true})
    async create(data: ProductsAddRequestType): Promise<ResponseDataType> {
        console.log('Create product ---'+ data)
        return await store.$repository.products.create(data);
    }
    @Action({rawError: true})
    async update(data:ProductsUpdateRequestType): Promise<ResponseDataType> {
        return await store.$repository.products.update(data)
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }

    /*
    * @Action({rawError: true})
    async create(data: SalonGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.salons.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: SalonGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.salons.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.salons.delete(data);
        return resp;
    }*/
}
export const ProductsStore = getModule(ProductsModule)